import React, { useState, useEffect, useMemo } from "react";
import Head from "../modules/Head";
import HeaderComponent from "../components/HeaderComponent";
import "../components/InputText.scss";
import Button from "../components/Button";
import "./PromjenaPassworda.scss";
import "../components/FormValidationsWarning.scss";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Link } from "react-router-dom";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Cookies } from "react-cookie";
import config from "../config.json";

function PromjenaPassworda() {
  const { baseUrl, token } = config;
  const navigate = useNavigate();
  const [responseMessage, setResponseMessage] = useState("");
  const [email, setEmail] = useState("");
  const cookies = useMemo(() => new Cookies(), []);

  useEffect(() => {
    const userEmail = cookies.get("pravnoLice");
    if (userEmail && typeof userEmail === "object" && userEmail.email) {
      setEmail(userEmail.email);
    } else {
      setEmail("");
    }
  }, [cookies]);

  const onSubmit = async (values, { resetForm }) => {
    try {
      const response = await axios.post(
        `${baseUrl}/auth/pravno-lice-promjena-passworda`,
        { ...values, email },
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
          },
        }
      );
      setResponseMessage(response.data.message);
      navigate("/hvala-password-promijenjen-pravno-lice");
    } catch (error) {
      setResponseMessage(error.response.data.message);
    }
    resetForm();
  };

  const { handleBlur, handleChange, handleSubmit, values, errors, touched } =
    useFormik({
      initialValues: {
        email: "",
        oldPassword: "",
        newPassword: "",
      },
      onSubmit,
      validationSchema: Yup.object({
        oldPassword: Yup.string()
          .required("Niste unijeli staru lozinku.")
          .min(8, "Stara lozinka mora sadržavati najmanje 8 znakova"),
        newPassword: Yup.string()
          .required("Niste unijeli novu lozinku.")
          .min(8, "Nova lozinka mora sadržavati najmanje 8 znakova")
          .notOneOf(
            [Yup.ref("oldPassword"), null],
            "Nova i stara lozinka moraju biti različite"
          ),
      }),
    });

  return (
    <form id="promjena-passworda" onSubmit={handleSubmit}>
      <Head title="Promjena Passworda" />
      <HeaderComponent title="PROMJENA PASSWORDA" />
      <label>Unesite stari password</label>
      <input
        type="password"
        name="oldPassword"
        id="stariPassword"
        onChange={handleChange}
        onBlur={handleBlur}
        value={values.oldPassword}
      />
      {touched.oldPassword && errors.oldPassword ? (
        <span className="input-error" id="stariPassword-error">
          {errors.oldPassword}
        </span>
      ) : null}
      <label style={{ marginTop: "1.2rem" }}>Unesite novi password</label>
      <input
        type="password"
        name="newPassword"
        id="noviPassword"
        onChange={handleChange}
        onBlur={handleBlur}
        value={values.newPassword}
      />
      {touched.newPassword && errors.newPassword ? (
        <span className="input-error" id="noviPassword-error">
          {errors.newPassword}
        </span>
      ) : null}
      <div>
        <Button
          type="submit"
          value="OK"
          id="primary"
          marginTop="2rem"
          marginRight="2rem"
        />
        <Link to="/">
          <Button value="ODUSTAJEM" type="danger" marginLeft="2rem">
            ODUSTAJEM
          </Button>
        </Link>
      </div>
      <br />
      <b className="responseMessage">{responseMessage}</b>
    </form>
  );
}

export default PromjenaPassworda;
